import { useRef, useContext, useState, useEffect } from 'react';

import styles from './ParticipantsToShareComponent.module.css'

import { GlobalContext } from "../../contexts/globalContext";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import DarkButtonComponent from '../commons/DarkButtonComponent';
import DisplayRoomComponent from '../popup/conferenceManageParticipants/DisplayRoomComponent';

import { GetMaxZIndex } from '../../utils/UtilitaryFunctions';

const ParticipantsToShareComponent = ({ setShowParticipantsToShare, ChangeModerator }) => {

    const { socketRef, currentConference } = useContext(GlobalContext);

    const firstRender = useRef(true)

    const [attachedParticipants, setAttachedParticipants] = useState([])
    const [displayedRoom, setDisplayedRoom] = useState()
    const [deskHeight, setDeskHeight] = useState()
    const [allRooms, setAllRooms] = useState([])
    const [isRemote, setIsRemote] = useState(false)
    const [tablePosition, setTablePosition] = useState()
    const [verifyRoomAdmin, setVerifyRoomAdmin] = useState(false)

    useEffect(() => {
        socketRef.current.emit('GET_CONFERENCE_ROOMS_BY_ID', currentConference.rooms, callback => {
            setAllRooms(callback)
            if (callback && callback.length > 0) {
                setDisplayedRoom(callback[0])

                var newDskHeight = 70;
                var mxx = Math.max(callback[0].desks_east?.length, callback[0].desks_west?.length);

                if (mxx > 0) {
                    var discac = Math.trunc(1200 / (mxx + 1.5));

                    if (discac > 0) {
                        newDskHeight = discac;
                    }
                }

                setDeskHeight(newDskHeight);
            }
        })

        return () => {
        }

    }, [])

    useEffect(() => {
        if (displayedRoom?._id && firstRender.current) {
            socketRef.current.emit("CONFERENCE_GET_ATTACHED_PARTICIPANTS_FROM_ROOM", {
                conferenceId: currentConference._id,
                roomId: displayedRoom._id
            },
                callback => {
                    if (!callback.error) {
                        setAttachedParticipants(callback.response)
                    }
                })
            firstRender.current = false
        }
    }, [displayedRoom])


    const shareToParticipant = (participant) => {

        ChangeModerator(participant);

        setShowParticipantsToShare(false);
    }

    const closePage = () => {
        setShowParticipantsToShare(false);
    }

    const changeRooms = (room) => {
        setDisplayedRoom(room)

        var newDskHeight = 70;
        var mxx = Math.max(room.desks_east?.length, room.desks_west?.length);

        if (mxx > 0) {
            var discac = Math.trunc(1200 / (mxx + 1.5));

            if (discac > 0) {
                newDskHeight = discac;
            }
        }

        setDeskHeight(newDskHeight);

        socketRef.current.emit("CONFERENCE_GET_ATTACHED_PARTICIPANTS_FROM_ROOM", {
            conferenceId: currentConference._id,
            roomId: room._id
        },
            callback => {
                if (!callback.error) {
                    setAttachedParticipants(callback.response)
                }
            })
    }

    return (
        <div className={styles.component} style={{ zIndex: GetMaxZIndex() + 1 }}>
            <div className={styles.rightBody}>
                <DisplayRoomComponent shareToParticipant={shareToParticipant} isInConference={true} attachedParticipants={attachedParticipants} tablePosition={tablePosition}
                    setTablePosition={setTablePosition} displayedRoom={displayedRoom} setDisplayedRoom={setDisplayedRoom} deskHeight={deskHeight} allRooms={allRooms}
                    isRemote={isRemote} setIsRemote={setIsRemote} changeRooms={changeRooms} selectedInvites={[]} setVerifyRoomAdmin={setVerifyRoomAdmin} verifyRoomAdmin={verifyRoomAdmin} />
            </div>

            <div style={{
                height: 80,
                borderRadius: 8,
                font: 'normal normal 600 40px/33px Bio Sans',
                position: "absolute",
                bottom: 30,
                left: "50%",
                transform: "translate(-50%,0)",
                display: 'flex',
                flexDirection: 'row'
            }}>
                <DarkButtonComponent
                    style={{ width: 353 }}
                    onClick={closePage}
                >
                    <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fas['xmark']} />Cancel
                </DarkButtonComponent>
            </div>
        </div>
    );

}

export default ParticipantsToShareComponent;